import React from 'react';
import { PropTypes } from 'prop-types';

export class StatsTile extends React.Component {
  static propTypes = {
    stats: PropTypes.any
  };

  renderChange() {
    let { stats } = this.props;
    let color = '';
    let icon = '';
    if (stats > 0) {
      color = 'green';
      icon = 'up-chevron';
      stats += '%';
    } else if (stats < 0) {
      color = 'red';
      icon = 'down-chevron';
      stats += '%';
    } else {
      stats = '';
      color = '';
      icon = '';
    }

    return (
      <div className={`basic-analytics-tiles ${color}-color`}>
        <span>{stats}</span>
        <i className={`custom-icons-${icon}`} />
      </div>
    );
  }

  render() {
    return this.renderChange();
  }
}
export default StatsTile;
